import { C, P0, S, abs, dot, fillAt, frac, max, min } from '../../geometry';

export const drop = {
  name: 'Drop',
  colors: ['#1FA2D6', '#3E63DD'],
  draw(m, t) {
    let sway = 2 * S(t * 1.3),
      tipY = 14,
      r = 22,
      rx = 1,
      rain = 0,
      splash = 0,
      pose = P0();
    if (m === 'happy') {
      sway = 4 * S(t * 6);
      splash = 1;
      pose.ty = -3 * abs(S(t * 6));
      rx = 1 + 0.04 * S(t * 12);
    }
    // Thinking: the tip keeps wobbling like water while rain streaks fall past.
    if (m === 'thinking') {
      sway = 7 * S(t * 2.2);
      rx = 1 + 0.05 * S(t * 4.4);
      rain = 1;
    }
    if (m === 'talking') {
      r = 22 + 2 * max(0, S(t * 10));
      tipY = 14 + 2 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      tipY = 6;
      r = 23;
      sway = S(t * 24);
    }
    if (m === 'paused') {
      sway = 13 + S(t * 0.7);
      tipY = 30;
      r = 23;
      rx = 1.08;
      pose.ty = 2;
    }
    const c = [50, 84 - r],
      tp = [50 + sway, tipY],
      dx = tp[0] - c[0],
      dy = tp[1] - c[1],
      d = Math.hypot(dx, dy),
      phi = Math.atan2(dy, dx),
      th = Math.acos(min(0.99, r / d));
    const ring = [...Array(17)].map((_, k) => {
      const a = phi + th + (k / 16) * (2 * Math.PI - 2 * th);
      return [c[0] + r * rx * C(a), c[1] + r * S(a)];
    });
    const body = [tp, ...ring, tp];
    const parts = [
      [18, 0],
      [83, 0.36],
      [27, 0.7],
    ].map(([x0, ph], i) => {
      if (splash) {
        const f = frac(t * 1.6 + ph),
          side = i === 1 ? 1 : -1,
          x = 50 + side * (22 + f * 16) + (i === 2 ? -6 : 0),
          y = 84 - 34 * f * (1 - f) * 2.2;
        return { c: 'b', pts: dot(x, y), o: S(Math.PI * f), snap: true };
      }
      const f = frac(t * 1.1 + ph),
        y = 6 + f * 80;
      return {
        c: 'b',
        pts: [
          [x0 + 1.5, y],
          [x0, y + 7],
        ],
        o: rain * S(Math.PI * f),
        snap: true,
      };
    });
    return {
      strokes: [{ c: 'a', pts: body, n: 40 }, ...parts],
      eyes: { x: 50 + sway * 0.08, y: c[1] - 1 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0),
};
